import {
    active_collections,
    active_dashboard,
    active_drop,
    active_faqs,
    active_newspaper,
    active_resources,
    active_settings,
    active_users,
    collections_icon,
    dashboard_icon,
    drop_icon,
    faqs_icon,
    newspaper_icon,
    resources_icon,
    settings_icon,
    users_icon,
    logo,
    logout_icon
} from '../../../../assets'


const SideBarData = [
    { 
        title: "Home", 
        TabIcon: dashboard_icon, 
        TabIconActive: active_dashboard, 
        path: "dashboard/home", 
    },
    // { 
    //     title: "My Collections", 
    //     TabIcon: collections_icon, 
    //     TabIconActive: active_collections, 
    //     path: "dashboard/my-collections" },
    { 
        title: "Resources", 
        TabIcon: resources_icon, 
        TabIconActive: active_resources, 
        iconClosed: drop_icon, 
        iconOpened: active_drop,
        path: "#",

        subNav: [
        {title: "Manage", path: "dashboard/resources"},
        {title: "Category", path: "dashboard/resources/category"},
        {title: "Tags", path: "dashboard/resources/tags"}
    
    ] 
},

    { 
        title: "FAQs", 
        TabIcon: faqs_icon, 
        TabIconActive: active_faqs, 
        iconClosed: drop_icon, 
        iconOpened: active_drop,
        path: "#", 

        subNav: [
            {title: "Manage", path: "dashboard/faqs"},
            {title: "Category", path: "dashboard/faqs/add-category"},
            
        
        ] 
    },
    { 
        title: "Newspapers", 
        TabIcon: newspaper_icon, 
        TabIconActive: active_newspaper, 
        path: "dashboard/newspapers"
    },
    { 
        title: "Users", 
        TabIcon: users_icon, 
        TabIconActive: active_users, 
        iconClosed: drop_icon, 
        iconOpened: active_drop,
        path: "#", 

        subNav: [
            {title: "Manage", path: "dashboard/users"},
            {title: "Roles", path: "dashboard/roles"},
            
        
        ]
    },
    // { 
    //     title: "Settings", 
    //     TabIcon: settings_icon, 
    //     TabIconActive: active_settings, 
    //     iconClosed: drop_icon, 
    //     iconOpened: active_drop,
    //     path: "dashboard/settings", 
        
    //     subNav: [
    //         // {title: "Roles", path: "dashboard/settings/roles"},
            
    //     ] 
    // },
    
];

export {SideBarData};





















// import {
//     active_collections,
//     active_dashboard,
//     active_drop,
//     active_faqs,
//     active_newspaper,
//     active_resources,
//     active_settings,
//     active_users,
//     collections_icon,
//     dashboard_icon,
//     drop_icon,
//     faqs_icon,
//     newspaper_icon,
//     resources_icon,
//     settings_icon,
//     users_icon,
//     logo,
//     logout_icon
// } from '../../../../assets'


// const SideBarData = [
//     { 
//         title: "Home", 
//         TabIcon: dashboard_icon, 
//         TabIconActive: active_dashboard, 
//         active: params.route === "/", 
//     },
//     { 
//         title: "My Collections", 
//         TabIcon: collections_icon, 
//         TabIconActive: active_collections, 
//         path: "my-collections" },
//     { 
//         title: "Resources", 
//         TabIcon: resources_icon, 
//         TabIconActive: active_resources, 
//         dropIcon: drop_icon, 
//         active: params.route === "resources",

//         subItems: [
//         {subText: "Category", active: params.route === "category"},
//         {subText: "Tags", active: params.route === "tags"}
    
//     ] 
// },

//     { 
//         title: "FAQs", 
//         TabIcon: faqs_icon, 
//         TabIconActive: active_faqs, 
//         active: params.route === "faqs" 
//     },
//     { 
//         title: "Newspapers", 
//         TabIcon: newspaper_icon, 
//         TabIconActive: active_newspaper, 
//         active: params.route === "newspaper" 
//     },
//     { 
//         title: "Users", 
//         TabIcon: users_icon, 
//         TabIconActive: active_users, 
//         active: params.route === "users" 
//     },
//     { 
//         title: "Settings", 
//         TabIcon: settings_icon, 
//         TabIconActive: active_settings, 
//         dropIcon: drop_icon, 
//         active: params.route === "settings", 
        
//         subItems: [
//             {subText: "Roles", active: params.route === "roles"},
//             {subText: "Permissions", active: params.route === "permissions"}
//         ] 
//     },
    
// ];

// export {SideBarData};